export default function InvoicePartner(data) {
    let invoice = data || {};
    this.id = invoice.id;
    this.amount = invoice.amount;
    this.created = new Date(invoice.created);
    this.number = invoice.number;
    this.pdfUrl = invoice.pdfUrl;
    this.paid = invoice.paid;
}